export default __webpack_public_path__ + "static/m-process-01-9b1fd3b46a5d4c2b195563549bc37abf.svg";